import { useSearchModels } from '#pplx/frontend/ask-models/hooks/useSearchModels.js';
import { SearchMode, SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
export function useDefaultComputerSearchModel() {
    const { getDefaultModelForMode } = useSearchModels({
        reason: 'default-computer-search-model',
    });
    return getDefaultModelForMode(SearchMode.ASI);
}
//# sourceMappingURL=useDefaultComputerSearchModel.js.map